import { Expose } from 'class-transformer'

export class SessionHistoryDataType {
  @Expose() value: number

  @Expose() totalSession: number
}
